import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { AppNames } from 'types';
import { TitleStyled } from './Layout.styles';

export const LayoutTitle = () => {
  const history = useHistory();
  const [appTitle, setAppTitle] = useState<AppNames | undefined>();
  useEffect(() => {
    const isMatchingAppName = (appNames: AppNames) =>
      history?.location?.pathname?.toLowerCase().includes(appNames.toLowerCase());
    if (isMatchingAppName('Leash')) {
      setAppTitle('Leash');
      document.title = 'Kennel | Leash';
      return;
    }

    if (isMatchingAppName('PupDocs')) {
      setAppTitle('PupDocs');
      document.title = 'Kennel | PupDocs';
      return;
    }

    if (isMatchingAppName('Pricing')) {
      setAppTitle('Pricing');
      document.title = 'Kennel | Pricing';
      return;
    }

    if (isMatchingAppName('DogPark')) {
      setAppTitle('DogPark');
      document.title = 'Kennel | DogPark';
      return;
    }

    setAppTitle('Kennel');
    document.title = 'Kennel';
  }, [history?.location?.pathname]);
  return (
    <TitleStyled>
      <span className="title-dash" />
      <span>{appTitle ?? ''}</span>
    </TitleStyled>
  );
};
